import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_CASH_REGISTER_CART_SELL_OFF } from '@softapps/wws/pos-core';
import { SellOff } from '@softapps/wws/pos-core';

@Injectable()
export class SellOffRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(date?: string): Promise<SellOff> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CART_SELL_OFF,
      queryParams: {
        date,
      },
    });
  }
}
